const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/oauth/consent/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickString } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { requireMember } from "@/routes/_app/guards";
import { getRootLoaderData } from "@/types/intl";
interface OAuthConsentSearch {
  client_id?: string;
  scope?: string;
}
export const Route = createFileRoute("/_app/oauth/consent/")({
  validateSearch: (raw: Record<string, unknown>): OAuthConsentSearch => ({
    client_id: pickString(raw.client_id),
    scope: pickString(raw.scope)
  }),
  beforeLoad: ({
    context: {
      queryClient
    },
    location
  }) => requireMember({
    queryClient,
    location
  }),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "globals.oauthConsent"
    });
    return {
      meta: buildPrivatePageMetaTags(t("title"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});